// Staging - Agri Co
export const AGRI_CO_SUPPLIER_UUID = '57c41f0a-eab9-47da-b653-0759a238d488';

// Staging - SpringField
export const DEMO_CHAT_UUID = '979aecb9-decc-49ef-8297-98f1c06a1efc';
export const DEMO_CHAT_RESTAURANT_UUID = 'bf1a5852-a631-44d4-b16c-7cd273bbf0ca';

// Staging - About Coffee
export const ABOUT_COFFEE_CHAT_UUID = '0c1e1a6d-46f8-489d-91e8-275d594e614c';
export const ABOUT_COFFEE_RESTAURANT_UUID =
  'a9804a0c-9691-4793-ba65-30d63b6b657a';

// Staging - Chipotle Mexican Grill
export const CHIPOTLE_MEXICAN_GRILL_CHAT_UUID =
  '70b50112-1d0d-4689-8e68-5e1c3ad148de';
export const CHIPOTLE_MEXICAN_GRILL_RESTAURANT_UUID =
  '2090cdef-5e94-48e0-8576-523e345e5e0d';

// Prod - SFF
export const SFF_SUPPLIER_UUID = 'f4d8ba32-df5a-4bad-bf94-cf0a1c89e109';

// Prod - Demo - 110 Grill
export const GRILL_110_CHAT_UUID = '42dfe399-fa40-422f-9555-aba1261a682d';
export const GRILL_110_RESTAURANT_UUID = 'af958011-3e7a-41fd-951d-b6da6c059d8c';

// Prod - Demo - Bob’s Burger Shack
export const BOBS_BURGER_SHACK_CHAT_UUID =
  '36e28ea7-e96a-4afa-9358-ff3a60e36319';
export const BOBS_BURGER_SHACK_RESTAURANT_UUID =
  'cf61ab35-4495-4778-9f40-72d62e9d4445';

// Prod - Flavor Heaven
export const FLAVOR_HEAVEN_CHAT_UUID = '8edd85b1-dc46-4c6c-b3de-8d1869e9c5ab';
export const FLAVOR_HEAVEN_RESTAURANT_UUID =
  '815eda58-6f6e-4555-a4e5-f8aadd20425a';

// Prod - Demo - General Nutrition
export const GENERAL_NUTRITION_CHAT_UUID =
  'd7e159fb-c64d-4ae5-b0d8-9d0d2616eaa7';
export const GENERAL_NUTRITION_RESTAURANT_UUID =
  '21515e60-f7af-4d53-9992-bbdefc79bd70';

// Prod - Demo - Gourmet Ice Cream
export const GOURMET_ICE_CREAM_CHAT_UUID =
  '84ad1339-d25c-437f-888f-50988eb61cff';
export const GOURMET_ICE_CREAM_RESTAURANT_UUID =
  '2827f789-f7d2-479e-86be-14140e15dad1';

// Prod - Demo - John’s Bar & Grill
export const JOHNS_BAR_AND_GRILL_CHAT_UUID =
  '60458aea-c6c4-43e7-a720-969acdcb1440';
export const JOHNS_BAR_AND_GRILL_RESTAURANT_UUID =
  'f6e0f517-9b89-46ad-90b9-0a88eda43092';

// Prod - Demo - John's Seafood House
export const JOHNS_SEAFOOD_HOUSE_CHAT_UUID =
  '1bbd3de6-e16c-40a4-bcc1-d75845ae7c19';
export const JOHNS_SEAFOOD_HOUSE_RESTAURANT_UUID =
  '50643a63-70ef-4059-b631-02d70d26a7f0';

// Prod - Nouveau Bistro
export const NOUVEAU_BISTRO_CHAT_UUID = 'b0efd479-cd8b-4977-b240-6e4e2d6f00ea';
export const NOUVEAU_BISTRO_RESTAURANT_UUID =
  '97ae6be8-4d5a-4bc1-8031-3aae786c7c03';

// Prod - Demo - Raza’s Restaurant
export const RAZAS_RESTAURANT_CHAT_UUID =
  '821400d2-d773-402a-b99d-a13fbd735181';
export const RAZAS_RESTAURANT_RESTAURANT_UUID =
  '3987f1cf-3131-4b1b-9fdd-1b004a91d144';

// Prod - Demo - Roese’s Rib Room
export const ROESES_RIB_ROOM_CHAT_UUID = '4801680f-374a-413f-aeea-6791d97353a6';
export const ROESES_RIB_ROOM_RESTAURANT_UUID =
  'f4412622-9c3d-4a65-a05f-f44883bcbecc';

// Prod - Demo - SpecialtyGoods
export const SPECIALTY_GOODS_CHAT_UUID = '64c763fe-d165-42b1-83a4-ce07345fe975';
export const SPECIALTY_GOODS_RESTAURANT_UUID =
  '3cf1f2f5-2419-437e-8e4d-418d4f06a3d1';

// Prod - Demo - The Duck Inn
export const THE_DUCK_INN_CHAT_UUID = 'a4bd2422-1b8e-42e6-9e0b-476e5ced13b2';
export const THE_DUCK_INN_RESTAURANT_UUID =
  'c80e4716-5180-4f07-b640-b758c22f95eb';

// Prod - Demo - The Surf Club Restaurant
export const THE_SURF_CLUB_RESTAURANT_CHAT_UUID =
  '70fe1764-a63e-47ad-95a4-dc2601d401da';
export const THE_SURF_CLUB_RESTAURANT_RESTAURANT_UUID =
  'a689e496-2990-4b6d-acf1-74c544757028';

// Prod - Demo - Tina's Tuna
export const TINA_TUNA_CHAT_UUID = '8d21af7f-9bd2-4794-bea7-624d57c13204';
export const TINA_TUNA_RESTAURANT_UUID = 'ea239204-46cc-408c-b067-e6711d5f01b7';

// Prod - Demo - 123 New
export const NEW_123_CHAT_UUID = '005c439f-9255-4a33-a7ce-f594fa80008d';
export const NEW_123_RESTAURANT_UUID = '0397e3be-cc38-4c4c-8208-25ab7b1afd4a';

// =============================================================================
// Bronco Demo Accounts (DSR-3748)
// =============================================================================

export const BRONCO_SUPPLIER_UUID = 'abf2eaaa-e22c-4553-a34e-d2300b073b26';

// --- Seafood Vertical ---
export const BLUE_FIN_MARKET_CHAT_UUID = 'b51d51c2-917f-4a3d-9c33-55cfbf1153e3';
export const BLUE_FIN_MARKET_RESTAURANT_UUID =
  '045d938f-503d-48b5-8815-cf506e9035b7';

export const CHOWDER_HOUSE_CHAT_UUID = '0a3d406a-d75b-46ea-a9e4-d10c1ff00b80';
export const CHOWDER_HOUSE_RESTAURANT_UUID =
  '721c3dd5-47d7-4b92-ba9e-cd47f311a4da';

export const COASTAL_KITCHEN_SEAFOOD_CHAT_UUID =
  'bc68da3f-f182-4c4b-98df-c9ecc6ece75d';
export const COASTAL_KITCHEN_SEAFOOD_RESTAURANT_UUID =
  '0b6d41f5-7f5b-45d0-a619-15f7102f3c35';

export const MALLORYS_SEAFOOD_CHAT_UUID =
  '8c676727-4908-4521-9481-4bc5b0edc765';
export const MALLORYS_SEAFOOD_RESTAURANT_UUID =
  '8b02be86-820c-40dd-9221-d975dcde61b9';

// --- Meat Vertical ---
export const LAKESHORE_DELI_CHAT_UUID = '78d0216a-73ee-446f-86ac-175bed0bfd28';
export const LAKESHORE_DELI_RESTAURANT_UUID =
  '9048a655-4b1e-435d-952a-b67b67ce957a';

export const MALLORYS_STEAKHOUSE_CHAT_UUID =
  'b8200fe4-8409-4261-bcbb-0af0063b5afb';
export const MALLORYS_STEAKHOUSE_RESTAURANT_UUID =
  '47ff61db-5ea5-4fb3-9edc-4c60101601de';

export const SUMMIT_STEAKHOUSE_CHAT_UUID =
  'e78d2bb1-3185-4a3d-b61d-0eca73f330cf';
export const SUMMIT_STEAKHOUSE_RESTAURANT_UUID =
  'bd89bd46-4a1a-42d0-98db-eb22292eb404';

export const THE_CARVING_BLOCK_CHAT_UUID =
  '9fd28a61-d8d9-4eea-b6fc-17aff856d31d';
export const THE_CARVING_BLOCK_RESTAURANT_UUID =
  '2d48e871-9b21-4fbd-aa68-14dee596715c';

// --- Produce Vertical ---
export const FIELDSTONE_KITCHEN_CHAT_UUID =
  'ebe30197-e51f-48cf-9328-a74f1e18d618';
export const FIELDSTONE_KITCHEN_RESTAURANT_UUID =
  '872d326f-e916-4ccd-ab8e-5313a1ee0ef8';

export const GARDEN_CAFE_CHAT_UUID = 'ab3058d4-5b81-40c5-ae5c-7ad2cfd914fc';
export const GARDEN_CAFE_RESTAURANT_UUID =
  '7eb7d0ed-ad54-4515-994f-421de7817260';

export const HOLLAND_PARK_CHAT_UUID = 'f15bab13-634d-486c-94ca-c25f1f6d3411';
export const HOLLAND_PARK_RESTAURANT_UUID =
  '9e32e5e1-6e4e-4655-aa65-006f54dada11';

export const WESS_BISTRO_CHAT_UUID = 'd985bf44-3c6c-40d9-a30e-6407acfeab7b';
export const WESS_BISTRO_RESTAURANT_UUID =
  'e1237dd1-834d-4934-96a6-d407d9363d68';

// --- Broadline Vertical ---
export const JEFFS_GOURMET_KITCHEN_CHAT_UUID =
  'c8973b60-a188-4eff-8cea-1fecb95fe718';
export const JEFFS_GOURMET_KITCHEN_RESTAURANT_UUID =
  'd64c3233-277c-411b-805a-4db7e9403777';

export const MARILUS_MARKET_CHAT_UUID = '7c3c6587-3d1e-459b-abd5-5c24bcb4cfd0';
export const MARILUS_MARKET_RESTAURANT_UUID =
  'e3b41385-5619-4b09-8424-034287a23d95';

export const THE_CARRIAGE_HOUSE_CHAT_UUID =
  'cf738384-348e-4289-8f60-cf8aa8d69154';
export const THE_CARRIAGE_HOUSE_RESTAURANT_UUID =
  '61787a9e-928f-463c-acf5-c987de84a0c2';

export const THE_DAILY_PLATE_CHAT_UUID = '9d793222-10c7-494c-8a91-583a1178121f';
export const THE_DAILY_PLATE_RESTAURANT_UUID =
  '2a6b645d-d441-4084-aca4-67d07a7caba3';

// --- Ice Cream Vertical ---
export const COWS_CREAMERY_CHAT_UUID = 'f6d317bc-7817-4fab-9e12-ddae203ff668';
export const COWS_CREAMERY_RESTAURANT_UUID =
  '01c93c62-abc3-4b43-9bbc-871818ea9df1';

export const DUTCH_DREAMS_CHAT_UUID = 'ee169942-72ff-4513-b034-1f4c3ff0bb37';
export const DUTCH_DREAMS_RESTAURANT_UUID =
  '31b6e879-2c91-4021-b922-7c339cea941e';

export const HUTCHS_ON_THE_BEACH_CHAT_UUID =
  '5700e8d0-6c0e-4fc4-8613-2299f60f7632';
export const HUTCHS_ON_THE_BEACH_RESTAURANT_UUID =
  '8cb5ebae-b532-4ed1-a420-ad38abe82c01';

export const THE_REAL_SCOOP_CHAT_UUID = 'cc92eae5-0cfa-4900-99e1-faad9486e2be';
export const THE_REAL_SCOOP_RESTAURANT_UUID =
  '677853c4-8c97-4b9f-b986-2cc3a0a70b59';

// --- C-Store Vertical ---
export const MAPLEWOOD_MART_CHAT_UUID = 'db467918-0a61-48a4-9084-6ad7de88b8a3';
export const MAPLEWOOD_MART_RESTAURANT_UUID =
  'd3ff3b85-ec06-49aa-a46d-ba5aa45ecc85';

export const RAYS_CSTORE_CHAT_UUID = '657d6908-a05f-4bf9-b14d-8bbc94cf12f9';
export const RAYS_CSTORE_RESTAURANT_UUID =
  'a314fe91-5d22-49f2-9a59-ce0be2c3efe7';

export const RIDGELINE_CSTORE_CHAT_UUID =
  'cc760e3b-adb1-4e14-93c6-918a08a3f976';
export const RIDGELINE_CSTORE_RESTAURANT_UUID =
  'bed99311-8ef8-4416-9b6a-7e0f1a78f670';

export const VALLEY_EXPRESS_CHAT_UUID = '77df254d-a0c3-44a4-b9bd-372371f48862';
export const VALLEY_EXPRESS_RESTAURANT_UUID =
  '86116dae-241e-49f1-b2f3-2f922e5a15e2';

// --- LP Vertical ---
export const FINE_AND_CURED_CHAT_UUID = '7843b91c-d27b-4c9b-b294-d2cc32e27903';
export const FINE_AND_CURED_RESTAURANT_UUID =
  '795d2877-e2a7-4f79-bf08-71dbe675548b';

export const KENS_CATERING_CHAT_UUID = '50098504-26a0-430e-b038-9ac25e1c9737';
export const KENS_CATERING_RESTAURANT_UUID =
  '58010406-db88-4eee-b45c-3afc3347055f';

export const THE_PROVISIONS_COUNTER_CHAT_UUID =
  'b4d6737e-1d31-4603-8ce4-a5fa0ba1f4cf';
export const THE_PROVISIONS_COUNTER_RESTAURANT_UUID =
  'a5650977-1cf8-4c2e-8e73-c9694604f6aa';

// --- Asian Vertical ---
export const ASIAN_FUSION_CHAT_UUID = 'cf411bd4-a9ad-4fa9-b17a-e4312287ee4f';
export const ASIAN_FUSION_RESTAURANT_UUID =
  '3858305a-5ca3-4708-9335-2e058ad896aa';

export const ASIAN_MARKET_CHAT_UUID = '42c69f0a-5c84-446a-b1c9-f73b22e8a69c';
export const ASIAN_MARKET_RESTAURANT_UUID =
  '73ecfa97-8106-406c-9036-940a112ecbed';

export const SIAM_DISH_CHAT_UUID = 'cfcb3f0b-90b9-4f03-832b-9d788e8b23a9';
export const SIAM_DISH_RESTAURANT_UUID = '38308b61-6423-4035-a03b-e26daf4eae8c';

// --- JanSan Vertical ---
export const CENTRAL_CONFERENCE_CENTRE_CHAT_UUID =
  '8a66cc9b-cd59-4015-8f30-6cd2d4c78288';
export const CENTRAL_CONFERENCE_CENTRE_RESTAURANT_UUID =
  '64d541cf-0fd6-4098-85c9-1e30774fd777';

export const DOWNTOWN_HIGH_SCHOOL_CHAT_UUID =
  '6e800a04-d594-49b6-a9b1-7bdb2a9bf76a';
export const DOWNTOWN_HIGH_SCHOOL_RESTAURANT_UUID =
  'ccaf083c-e627-4eec-9ab1-29c0108216e1';

export const ST_MORITZ_HOTEL_CHAT_UUID = '95843133-7700-46b1-a6b1-02f5fcdad85d';
export const ST_MORITZ_HOTEL_RESTAURANT_UUID =
  '235f9493-fc3a-4e6c-ac72-c375f339b2c5';

/**
 * Lookup map from restaurant UUID to chat UUID for Bronco demo accounts.
 * Used by account detail loaders to find mock data keyed by chat UUID.
 */
export const BRONCO_DEMO_RESTAURANT_TO_CHAT: Record<string, string> = {
  [ASIAN_FUSION_RESTAURANT_UUID]: ASIAN_FUSION_CHAT_UUID,
  [ASIAN_MARKET_RESTAURANT_UUID]: ASIAN_MARKET_CHAT_UUID,
  [BLUE_FIN_MARKET_RESTAURANT_UUID]: BLUE_FIN_MARKET_CHAT_UUID,
  [CENTRAL_CONFERENCE_CENTRE_RESTAURANT_UUID]:
    CENTRAL_CONFERENCE_CENTRE_CHAT_UUID,
  [CHOWDER_HOUSE_RESTAURANT_UUID]: CHOWDER_HOUSE_CHAT_UUID,
  [COASTAL_KITCHEN_SEAFOOD_RESTAURANT_UUID]: COASTAL_KITCHEN_SEAFOOD_CHAT_UUID,
  [COWS_CREAMERY_RESTAURANT_UUID]: COWS_CREAMERY_CHAT_UUID,
  [DOWNTOWN_HIGH_SCHOOL_RESTAURANT_UUID]: DOWNTOWN_HIGH_SCHOOL_CHAT_UUID,
  [DUTCH_DREAMS_RESTAURANT_UUID]: DUTCH_DREAMS_CHAT_UUID,
  [FIELDSTONE_KITCHEN_RESTAURANT_UUID]: FIELDSTONE_KITCHEN_CHAT_UUID,
  [FINE_AND_CURED_RESTAURANT_UUID]: FINE_AND_CURED_CHAT_UUID,
  [GARDEN_CAFE_RESTAURANT_UUID]: GARDEN_CAFE_CHAT_UUID,
  [HOLLAND_PARK_RESTAURANT_UUID]: HOLLAND_PARK_CHAT_UUID,
  [HUTCHS_ON_THE_BEACH_RESTAURANT_UUID]: HUTCHS_ON_THE_BEACH_CHAT_UUID,
  [JEFFS_GOURMET_KITCHEN_RESTAURANT_UUID]: JEFFS_GOURMET_KITCHEN_CHAT_UUID,
  [KENS_CATERING_RESTAURANT_UUID]: KENS_CATERING_CHAT_UUID,
  [LAKESHORE_DELI_RESTAURANT_UUID]: LAKESHORE_DELI_CHAT_UUID,
  [MALLORYS_SEAFOOD_RESTAURANT_UUID]: MALLORYS_SEAFOOD_CHAT_UUID,
  [MALLORYS_STEAKHOUSE_RESTAURANT_UUID]: MALLORYS_STEAKHOUSE_CHAT_UUID,
  [MAPLEWOOD_MART_RESTAURANT_UUID]: MAPLEWOOD_MART_CHAT_UUID,
  [MARILUS_MARKET_RESTAURANT_UUID]: MARILUS_MARKET_CHAT_UUID,
  [RAYS_CSTORE_RESTAURANT_UUID]: RAYS_CSTORE_CHAT_UUID,
  [RIDGELINE_CSTORE_RESTAURANT_UUID]: RIDGELINE_CSTORE_CHAT_UUID,
  [SIAM_DISH_RESTAURANT_UUID]: SIAM_DISH_CHAT_UUID,
  [ST_MORITZ_HOTEL_RESTAURANT_UUID]: ST_MORITZ_HOTEL_CHAT_UUID,
  [SUMMIT_STEAKHOUSE_RESTAURANT_UUID]: SUMMIT_STEAKHOUSE_CHAT_UUID,
  [THE_CARRIAGE_HOUSE_RESTAURANT_UUID]: THE_CARRIAGE_HOUSE_CHAT_UUID,
  [THE_CARVING_BLOCK_RESTAURANT_UUID]: THE_CARVING_BLOCK_CHAT_UUID,
  [THE_DAILY_PLATE_RESTAURANT_UUID]: THE_DAILY_PLATE_CHAT_UUID,
  [THE_PROVISIONS_COUNTER_RESTAURANT_UUID]: THE_PROVISIONS_COUNTER_CHAT_UUID,
  [THE_REAL_SCOOP_RESTAURANT_UUID]: THE_REAL_SCOOP_CHAT_UUID,
  [VALLEY_EXPRESS_RESTAURANT_UUID]: VALLEY_EXPRESS_CHAT_UUID,
  [WESS_BISTRO_RESTAURANT_UUID]: WESS_BISTRO_CHAT_UUID,
};

/** All Bronco demo chat UUIDs grouped by vertical. */
export const BRONCO_DEMO_CHATS_BY_VERTICAL: Record<string, string[]> = {
  asian: [ASIAN_FUSION_CHAT_UUID, ASIAN_MARKET_CHAT_UUID, SIAM_DISH_CHAT_UUID],
  broadline: [
    JEFFS_GOURMET_KITCHEN_CHAT_UUID,
    MARILUS_MARKET_CHAT_UUID,
    THE_CARRIAGE_HOUSE_CHAT_UUID,
    THE_DAILY_PLATE_CHAT_UUID,
  ],
  cStore: [
    MAPLEWOOD_MART_CHAT_UUID,
    RAYS_CSTORE_CHAT_UUID,
    RIDGELINE_CSTORE_CHAT_UUID,
    VALLEY_EXPRESS_CHAT_UUID,
  ],
  iceCream: [
    COWS_CREAMERY_CHAT_UUID,
    DUTCH_DREAMS_CHAT_UUID,
    HUTCHS_ON_THE_BEACH_CHAT_UUID,
    THE_REAL_SCOOP_CHAT_UUID,
  ],
  janSan: [
    CENTRAL_CONFERENCE_CENTRE_CHAT_UUID,
    DOWNTOWN_HIGH_SCHOOL_CHAT_UUID,
    ST_MORITZ_HOTEL_CHAT_UUID,
  ],
  lp: [
    FINE_AND_CURED_CHAT_UUID,
    KENS_CATERING_CHAT_UUID,
    THE_PROVISIONS_COUNTER_CHAT_UUID,
  ],
  meat: [
    LAKESHORE_DELI_CHAT_UUID,
    MALLORYS_STEAKHOUSE_CHAT_UUID,
    SUMMIT_STEAKHOUSE_CHAT_UUID,
    THE_CARVING_BLOCK_CHAT_UUID,
  ],
  produce: [
    FIELDSTONE_KITCHEN_CHAT_UUID,
    GARDEN_CAFE_CHAT_UUID,
    HOLLAND_PARK_CHAT_UUID,
    WESS_BISTRO_CHAT_UUID,
  ],
  seafood: [
    BLUE_FIN_MARKET_CHAT_UUID,
    CHOWDER_HOUSE_CHAT_UUID,
    COASTAL_KITCHEN_SEAFOOD_CHAT_UUID,
    MALLORYS_SEAFOOD_CHAT_UUID,
  ],
};

/** Flat list of all Bronco demo chat UUIDs. */
export const BRONCO_DEMO_CHATS = Object.values(
  BRONCO_DEMO_CHATS_BY_VERTICAL,
).flat();

/**
 * Restaurant metadata for Bronco demo accounts, keyed by chat UUID.
 * Used by the FYP (Insights Hub) to build hub cards that require restaurant
 * name and address as CompleteTranslation fields.
 */
export const BRONCO_DEMO_RESTAURANT_META: Record<
  string,
  { address: string; name: string; restaurantUUID: string }
> = {
  // --- Asian ---
  [ASIAN_FUSION_CHAT_UUID]: {
    address: '88 Spadina Ave, Toronto, ON M5V 2J7, Canada',
    name: 'Asian Fusion',
    restaurantUUID: ASIAN_FUSION_RESTAURANT_UUID,
  },
  [ASIAN_MARKET_CHAT_UUID]: {
    address: '412 Dundas St W, Toronto, ON M5T 1G7, Canada',
    name: 'Asian Market',
    restaurantUUID: ASIAN_MARKET_RESTAURANT_UUID,
  },
  // --- Seafood ---
  [BLUE_FIN_MARKET_CHAT_UUID]: {
    address: '55 Harbour Front, Halifax, NS B3J 1S9, Canada',
    name: 'Blue Fin Market',
    restaurantUUID: BLUE_FIN_MARKET_RESTAURANT_UUID,
  },
  // --- JanSan ---
  [CENTRAL_CONFERENCE_CENTRE_CHAT_UUID]: {
    address: '1 Blue Jays Way, Toronto, ON M5V 1J1, Canada',
    name: 'Central Conference Centre',
    restaurantUUID: CENTRAL_CONFERENCE_CENTRE_RESTAURANT_UUID,
  },
  [CHOWDER_HOUSE_CHAT_UUID]: {
    address: '14 Wharf Rd, Lunenburg, NS B0J 2C0, Canada',
    name: 'Chowder House',
    restaurantUUID: CHOWDER_HOUSE_RESTAURANT_UUID,
  },
  [COASTAL_KITCHEN_SEAFOOD_CHAT_UUID]: {
    address: "200 Waterfront Dr, St. John's, NL A1C 1A4, Canada",
    name: 'Coastal Kitchen Seafood',
    restaurantUUID: COASTAL_KITCHEN_SEAFOOD_RESTAURANT_UUID,
  },
  // --- Ice Cream ---
  [COWS_CREAMERY_CHAT_UUID]: {
    address: '17 Water St, Charlottetown, PE C1A 1A3, Canada',
    name: "Cow's Creamery",
    restaurantUUID: COWS_CREAMERY_RESTAURANT_UUID,
  },
  [DOWNTOWN_HIGH_SCHOOL_CHAT_UUID]: {
    address: '455 Jarvis St, Toronto, ON M4Y 2G8, Canada',
    name: 'Downtown High School',
    restaurantUUID: DOWNTOWN_HIGH_SCHOOL_RESTAURANT_UUID,
  },
  [DUTCH_DREAMS_CHAT_UUID]: {
    address: '78 Vaughan Rd, Toronto, ON M6C 2M1, Canada',
    name: 'Dutch Dreams',
    restaurantUUID: DUTCH_DREAMS_RESTAURANT_UUID,
  },
  // --- Produce ---
  [FIELDSTONE_KITCHEN_CHAT_UUID]: {
    address: '12 Mill St, Caledon, ON L7E 1A1, Canada',
    name: 'Fieldstone Kitchen',
    restaurantUUID: FIELDSTONE_KITCHEN_RESTAURANT_UUID,
  },
  // --- LP ---
  [FINE_AND_CURED_CHAT_UUID]: {
    address: '220 Queen St W, Toronto, ON M5V 1Z4, Canada',
    name: 'Fine and Cured',
    restaurantUUID: FINE_AND_CURED_RESTAURANT_UUID,
  },
  [GARDEN_CAFE_CHAT_UUID]: {
    address: '77 Queen St S, Kitchener, ON N2G 1W1, Canada',
    name: 'Garden Cafe',
    restaurantUUID: GARDEN_CAFE_RESTAURANT_UUID,
  },
  [HOLLAND_PARK_CHAT_UUID]: {
    address: '315 Holland Ave, Ottawa, ON K1Y 0Y5, Canada',
    name: 'Holland Park',
    restaurantUUID: HOLLAND_PARK_RESTAURANT_UUID,
  },
  [HUTCHS_ON_THE_BEACH_CHAT_UUID]: {
    address: '1 Lake Dr, Huntsville, ON P1H 1H1, Canada',
    name: "Hutch's on the Beach",
    restaurantUUID: HUTCHS_ON_THE_BEACH_RESTAURANT_UUID,
  },
  // --- Broadline ---
  [JEFFS_GOURMET_KITCHEN_CHAT_UUID]: {
    address: '156 Front St, Belleville, ON K8N 2Y7, Canada',
    name: "Jeff's Gourmet Kitchen",
    restaurantUUID: JEFFS_GOURMET_KITCHEN_RESTAURANT_UUID,
  },
  [KENS_CATERING_CHAT_UUID]: {
    address: '65 Weber St N, Waterloo, ON N2J 3G9, Canada',
    name: "Ken's Catering",
    restaurantUUID: KENS_CATERING_RESTAURANT_UUID,
  },
  // --- Meat ---
  [LAKESHORE_DELI_CHAT_UUID]: {
    address: '340 Lakeshore Rd E, Oakville, ON L6J 1J6, Canada',
    name: 'Lakeshore Deli',
    restaurantUUID: LAKESHORE_DELI_RESTAURANT_UUID,
  },
  [MALLORYS_SEAFOOD_CHAT_UUID]: {
    address: '78 Pier St, Victoria, BC V8W 1T3, Canada',
    name: "Mallory's Seafood",
    restaurantUUID: MALLORYS_SEAFOOD_RESTAURANT_UUID,
  },
  [MALLORYS_STEAKHOUSE_CHAT_UUID]: {
    address: '620 Church St, Toronto, ON M4Y 2G2, Canada',
    name: "Mallory's Steakhouse",
    restaurantUUID: MALLORYS_STEAKHOUSE_RESTAURANT_UUID,
  },
  // --- C-Store ---
  [MAPLEWOOD_MART_CHAT_UUID]: {
    address: '112 Maple Ave, Burlington, ON L7L 1E4, Canada',
    name: 'Maplewood Mart',
    restaurantUUID: MAPLEWOOD_MART_RESTAURANT_UUID,
  },
  [MARILUS_MARKET_CHAT_UUID]: {
    address: '423 Bloor St W, Toronto, ON M5S 1X5, Canada',
    name: "Marilu's Market",
    restaurantUUID: MARILUS_MARKET_RESTAURANT_UUID,
  },
  [RAYS_CSTORE_CHAT_UUID]: {
    address: '501 Dundas St, Woodstock, ON N4S 1C2, Canada',
    name: "Ray's C-Store",
    restaurantUUID: RAYS_CSTORE_RESTAURANT_UUID,
  },
  [RIDGELINE_CSTORE_CHAT_UUID]: {
    address: '32 Ridge Rd, Sudbury, ON P3E 3T1, Canada',
    name: 'Ridgeline C-Store',
    restaurantUUID: RIDGELINE_CSTORE_RESTAURANT_UUID,
  },
  [SIAM_DISH_CHAT_UUID]: {
    address: '130 King St E, Toronto, ON M5C 1G6, Canada',
    name: 'Siam Dish',
    restaurantUUID: SIAM_DISH_RESTAURANT_UUID,
  },
  [ST_MORITZ_HOTEL_CHAT_UUID]: {
    address: '4599 Chateau Blvd, Whistler, BC V8E 0Z5, Canada',
    name: 'St. Moritz Hotel',
    restaurantUUID: ST_MORITZ_HOTEL_RESTAURANT_UUID,
  },
  [SUMMIT_STEAKHOUSE_CHAT_UUID]: {
    address: '195 Mountain Rd, Banff, AB T1L 1B3, Canada',
    name: 'Summit Steakhouse',
    restaurantUUID: SUMMIT_STEAKHOUSE_RESTAURANT_UUID,
  },
  [THE_CARRIAGE_HOUSE_CHAT_UUID]: {
    address: '88 Main St, Niagara-on-the-Lake, ON L0S 1J0, Canada',
    name: 'The Carriage House',
    restaurantUUID: THE_CARRIAGE_HOUSE_RESTAURANT_UUID,
  },
  [THE_CARVING_BLOCK_CHAT_UUID]: {
    address: '44 King St W, Hamilton, ON L8P 1A2, Canada',
    name: 'The Carving Block',
    restaurantUUID: THE_CARVING_BLOCK_RESTAURANT_UUID,
  },
  [THE_DAILY_PLATE_CHAT_UUID]: {
    address: '290 Danforth Ave, Toronto, ON M4K 1N6, Canada',
    name: 'The Daily Plate',
    restaurantUUID: THE_DAILY_PLATE_RESTAURANT_UUID,
  },
  [THE_PROVISIONS_COUNTER_CHAT_UUID]: {
    address: '18 George St, Stratford, ON N5A 1A1, Canada',
    name: 'The Provisions Counter',
    restaurantUUID: THE_PROVISIONS_COUNTER_RESTAURANT_UUID,
  },
  [THE_REAL_SCOOP_CHAT_UUID]: {
    address: '55 Division St, Cobourg, ON K9A 3P3, Canada',
    name: 'The Real Scoop',
    restaurantUUID: THE_REAL_SCOOP_RESTAURANT_UUID,
  },
  [VALLEY_EXPRESS_CHAT_UUID]: {
    address: '8 Valley Dr, Peterborough, ON K9J 6X3, Canada',
    name: 'Valley Express',
    restaurantUUID: VALLEY_EXPRESS_RESTAURANT_UUID,
  },
  [WESS_BISTRO_CHAT_UUID]: {
    address: '91 Brock St, Kingston, ON K7L 1R9, Canada',
    name: "Wes's Bistro",
    restaurantUUID: WESS_BISTRO_RESTAURANT_UUID,
  },
};

// =============================================================================
// End Bronco Demo Accounts
// =============================================================================

// Prod - Devin's personal testing account - Devustomer
export const DEVUSTOMER_CHAT_UUID = 'de9dbd5c-223f-4eea-bda4-d49d97883402';
export const DEVUSTOMER_RESTAURANT_UUID =
  '3e27097b-ff62-4d5a-8089-b96b251ed906';

// Prod - Ryan's personal testing account - Ryans Rippin Restaurant
export const RYANS_RIPPIN_RESTAURANT_CHAT_UUID =
  '802a1bf3-3b58-4b71-81de-6476894ea7cd';
export const RYANS_RIPPIN_RESTAURANT_RESTAURANT_UUID =
  '6b39ca55-ce40-4988-80f2-8e93a6291570';

export const PRODUCTION_DEMO_CHATS = [
  BOBS_BURGER_SHACK_CHAT_UUID,
  FLAVOR_HEAVEN_CHAT_UUID,
  JOHNS_BAR_AND_GRILL_CHAT_UUID,
  NOUVEAU_BISTRO_CHAT_UUID,
  RAZAS_RESTAURANT_CHAT_UUID,
  ROESES_RIB_ROOM_CHAT_UUID,
  NEW_123_CHAT_UUID,
  GRILL_110_CHAT_UUID,
  SPECIALTY_GOODS_CHAT_UUID,
  GOURMET_ICE_CREAM_CHAT_UUID,
  GENERAL_NUTRITION_CHAT_UUID,
  THE_DUCK_INN_CHAT_UUID,
  THE_SURF_CLUB_RESTAURANT_CHAT_UUID,
  JOHNS_SEAFOOD_HOUSE_CHAT_UUID,
  TINA_TUNA_CHAT_UUID,
  RYANS_RIPPIN_RESTAURANT_CHAT_UUID,
  ...BRONCO_DEMO_CHATS,
];
